import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { CamposPadrao } from '@/types/tipo-ativo';

interface CamposPadraoSelectorProps {
  value?: CamposPadrao;
  onChange: (value: CamposPadrao) => void;
}

const camposDisponiveis = {
  basico: [
    { value: 'nome', label: 'Nome' },
    { value: 'tipo_id', label: 'Tipo' },
    { value: 'status_operacional', label: 'Status Operacional' },
    { value: 'ambiente', label: 'Ambiente' },
    { value: 'localizacao_id', label: 'Localização' },
    { value: 'fabricante_id', label: 'Fabricante' },
    { value: 'modelo', label: 'Modelo' },
    { value: 'numero_serie', label: 'Número de Série' },
    { value: 'patrimonio', label: 'Patrimônio' },
    { value: 'descricao', label: 'Descrição' },
  ],
  tecnico: [
    { value: 'ips', label: 'IPs' },
    { value: 'mac_addresses', label: 'MAC Addresses' },
    { value: 'sistema_operacional', label: 'Sistema Operacional' },
    { value: 'versao_firmware', label: 'Versão Firmware' },
    { value: 'software_instalado', label: 'Software Instalado' },
    { value: 'dependencias', label: 'Dependências' },
    { value: 'capacidade', label: 'Capacidade' },
    { value: 'host_parent_id', label: 'Host Parent' },
    { value: 'virtualizacao_tipo', label: 'Tipo de Virtualização' },
  ],
  negocio: [
    { value: 'client_id', label: 'Cliente' },
    { value: 'dono_negocio_id', label: 'Dono de Negócio' },
    { value: 'grupo_responsavel_id', label: 'Grupo Responsável' },
    { value: 'departamento_id', label: 'Departamento' },
    { value: 'proprietario_id', label: 'Proprietário' },
    { value: 'centro_de_custo', label: 'Centro de Custo' },
    { value: 'valor_aquisicao', label: 'Valor de Aquisição' },
    { value: 'valor_atual', label: 'Valor Atual' },
    { value: 'taxa_depreciacao', label: 'Taxa de Depreciação' },
    { value: 'valor_residual', label: 'Valor Residual' },
    { value: 'tipo_aquisicao', label: 'Tipo de Aquisição' },
    { value: 'business_criticality', label: 'Criticidade de Negócio' },
    { value: 'sla_esperado', label: 'SLA Esperado' },
    { value: 'situacao_legal', label: 'Situação Legal' },
    { value: 'observacoes_negocio', label: 'Observações de Negócio' },
    { value: 'contrato_id', label: 'Contrato' },
  ],
  seguranca: [
    { value: 'nivel_acesso', label: 'Nível de Acesso' },
    { value: 'classificacao_dados', label: 'Classificação de Dados' },
    { value: 'requer_criptografia', label: 'Requer Criptografia' },
    { value: 'certificados', label: 'Certificados' },
    { value: 'compliance', label: 'Compliance' },
    { value: 'vulnerabilidades_conhecidas', label: 'Vulnerabilidades Conhecidas' },
  ],
};

export const CamposPadraoSelector = ({ value = {}, onChange }: CamposPadraoSelectorProps) => {
  const handleToggle = (tab: keyof CamposPadrao, campo: string) => {
    const currentFields = value[tab] || [];
    const newFields = currentFields.includes(campo)
      ? currentFields.filter(f => f !== campo)
      : [...currentFields, campo];
    
    onChange({
      ...value,
      [tab]: newFields,
    });
  };

  return (
    <Tabs defaultValue="basico" className="w-full">
      <TabsList className="grid w-full grid-cols-4">
        <TabsTrigger value="basico">Básico</TabsTrigger>
        <TabsTrigger value="tecnico">Técnico</TabsTrigger>
        <TabsTrigger value="negocio">Negócio</TabsTrigger>
        <TabsTrigger value="seguranca">Segurança</TabsTrigger>
      </TabsList>

      {Object.entries(camposDisponiveis).map(([tab, campos]) => (
        <TabsContent key={tab} value={tab} className="space-y-2">
          <div className="grid grid-cols-2 gap-2">
            {campos.map((campo) => (
              <div key={campo.value} className="flex items-center space-x-2">
                <Checkbox
                  id={`${tab}-${campo.value}`}
                  checked={value[tab as keyof CamposPadrao]?.includes(campo.value) || false}
                  onCheckedChange={() => handleToggle(tab as keyof CamposPadrao, campo.value)}
                />
                <Label
                  htmlFor={`${tab}-${campo.value}`}
                  className="text-sm font-normal cursor-pointer"
                >
                  {campo.label}
                </Label>
              </div>
            ))}
          </div>
        </TabsContent>
      ))}
    </Tabs>
  );
};
